import manufacturersOverviewRedux from 'Modules/manufacturers/views/overview/redux/reducer';
import refreshFirmwareRedux from 'Modules/manufacturers/.components/refreshFirmware/redux/reducer';
import createEditPartNumberRedux from 'Modules/manufacturers/.components/partNumbersTab/.components/createEditPartNumber/redux/reducer';
import deletePartNumberRedux from 'Modules/manufacturers/.components/partNumbersTab/.components/deletePartNumber/redux/reducer';
import assignFirmwareRedux from 'Modules/manufacturers/.components/firmwareTab/.components/assignFirmware/redux/reducer';
import refreshDevicesConfigRedux from 'Modules/manufacturers/.components/refreshDevicesConfig/redux/reducer';
import createEditCannedCommandRedux from 'Modules/manufacturers/.components/cannedCommandsTab/.components/createEditCannedCommand/redux/reducer';
import deleteCannedCommandRedux from 'Modules/manufacturers/.components/cannedCommandsTab/.components/deleteCannedCommand/redux/reducer';
import createEditUnitTypeRedux from 'Modules/manufacturers/.components/unitTypesTab/.components/createEditUnitType/redux/reducer';
import deleteUnitTypeRedux from 'Modules/manufacturers/.components/unitTypesTab/.components/deleteUnitType/redux/reducer';
import showUnitTypeEventsRedux from 'Modules/manufacturers/.components/unitTypesTab/.components/showUnitTypeEvents/redux/reducer';
import createEditManufacturerRedux from 'Modules/manufacturers/views/.components/createEditManufacturer/redux/reducer';
import deleteManufacturerRedux from 'Modules/manufacturers/views/.components/deleteManufacturer/redux/reducer';
import createEditDeviceModelRedux from 'Modules/manufacturers/.components/deviceModelsTab/.components/createEditDeviceModel/redux/reducer';
import editAlertTypeSupportedRedux from 'Modules/manufacturers/.components/deviceModelsTab/.components/createEditDeviceModel/.components/editAlertTypeSupported/redux/reducer';
import bulkAssignAlertTypesRedux  from 'Modules/manufacturers/.components/deviceModelsTab/.components/bulkAssignAlertTypes/redux/reducer';
import syncCTCInformationRedux from 'Modules/manufacturers/views/.components/syncCTCInformation/redux/reducer';

//export redux objects
export default {
	manufacturersOverviewRedux,
	refreshFirmwareRedux,
	createEditPartNumberRedux,
	deletePartNumberRedux,
	assignFirmwareRedux,
	refreshDevicesConfigRedux,
	createEditCannedCommandRedux,
	deleteCannedCommandRedux,
	createEditUnitTypeRedux,
	deleteUnitTypeRedux,
	showUnitTypeEventsRedux,
	createEditManufacturerRedux,
	deleteManufacturerRedux,
	createEditDeviceModelRedux,
	editAlertTypeSupportedRedux,
	bulkAssignAlertTypesRedux,
	syncCTCInformationRedux,
};